<script lang="ts">
    import { sendUIInteractionAnalyticsEvent } from "@app/services/analytics/analytics-send-event";

    import {
        COMMON__details,
        DICTIONARY__copyToClipboard,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { copyToClipboard } from "@app/utils/copyToClipboard";
    import Menu from "../Menu.svelte";

    export let open: boolean;
    export let translationId: string;
    export let phrase: string;
    export let onClose: () => void;
    export let activator: HTMLElement;
    function copyToClipboardLocal() {
        copyToClipboard(phrase);
        sendUIInteractionAnalyticsEvent({
            action: "translation-menu-clipboard",
        });
    }
</script>

<Menu {open} {onClose} {activator} >
    {#if phrase}
        <li>
            <button
                class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700"
                on:click={copyToClipboardLocal}
            >
                {getMessage(DICTIONARY__copyToClipboard)}
            </button>
        </li>
    {/if}
    <li>
        <a
            href="https://app.glosbe.com/translation?id={translationId}"
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700"
        >
            {getMessage(COMMON__details)}
        </a>
    </li>
</Menu>
